import * as React from 'react';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import Retracked from 'js/lib/retracked';
import type { EventData, WithTrackingData } from 'js/lib/retracked';

import { ClipsErrorMessage } from 'bundles/clips/components/ClipsErrorMessage';
import { NotFound } from 'bundles/common/components/withNotFound';

type LoggedOutUserProps = {
  router: InjectedRouter;
  _eventData: EventData;
  _withTrackingData: WithTrackingData;
  courseSlug: string;
  programSlug?: string;
  orgSlug?: string;
  itemId: string;
};

class RouteToLoginModal extends React.Component<LoggedOutUserProps> {
  componentDidMount() {
    const { router, _eventData, _withTrackingData, courseSlug, programSlug, orgSlug, itemId } = this.props;
    router.replace({
      pathname: router.location.pathname,
      query: { ...router.location.query, ...{ authMode: 'login' } },
    });
    Retracked.trackComponent(
      _eventData,
      { courseSlug, programSlug, orgSlug, itemId },
      'short_form_content_show_login_modal',
      'view',
      _withTrackingData
    );
  }

  render() {
    return <NotFound description={<ClipsErrorMessage />} />;
  }
}

export default RouteToLoginModal;
